import { activeIndicatorUrl } from './activeIndicatorUrl';
import { pxToRem } from '../../../../utils';
export var accordionTitleStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    return {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '.5rem 0',
      cursor: p.disabled ? 'default' : 'pointer'
    };
  },
  contentWrapper: function contentWrapper(_ref2) {
    var p = _ref2.props;
    return Object.assign({
      display: ['grid', '-ms-grid'],
      gridTemplateColumns: 'auto',
      msGridColumns: 'auto'
    }, p.content && {
      gridTemplateColumns: 'auto 1fr',
      msGridColumns: 'auto 1fr'
    });
  },
  indicator: function indicator(_ref3) {
    var p = _ref3.props,
        v = _ref3.variables,
        rtl = _ref3.rtl;
    return Object.assign({
      alignItems: 'center',
      display: 'inline-flex',
      backgroundImage: activeIndicatorUrl(v.color, p.active),
      backgroundPosition: 'center'
    }, rtl && {
      transform: "scaleX(-1)"
    }, {
      content: '" "',
      overflow: 'hidden',
      height: '100%',
      width: pxToRem(16),
      msGridColumn: '1'
    });
  },
  content: function content() {
    return {
      alignItems: 'center',
      display: 'grid',
      msGridColumn: '2'
    };
  }
};
//# sourceMappingURL=accordionTitleStyles.js.map
